import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import validate from 'validate.js';
import Grid from '@material-ui/core/Grid';
import FormTextField from '../legacyForm/FormTextField';
import FormSelect from '../legacyForm/FormSelect';
import Pesel from '../../utils/pesel';

const required = value => value ? undefined : 'Pole jest wymagane';
const pesel = value => new Pesel(value).isValid() ? undefined : 'Numer pesel nie jest prawidłowy';
const email = value => validate.single(value, { email: true }) ? 'Ades nie jest prawidłowy' : undefined;
const year = value => validate.single(value, { numericality: { onlyInteger: true, greaterThanOrEqualTo: 1900, lessThanOrEqualTo: 2021 } }) ? 'Rok nie jest prawidłowy' : undefined;
const phoneNumber = isOptional => value => {
  if (!value || /^\s*$/.test(value)) {
    if (!isOptional) return 'Pole jest wymagane';
    return undefined;
  }

  if (!/^\s*(\d\s*){9}$/.test(value)) return 'Numer telefonu musi składać się z 9 cyfr';
  return undefined;
};

const phoneNumberOptional = phoneNumber(true);
const phoneNumberRequired = phoneNumber(false);

const ApplicantDataNaturalPerson = ({ voterRequiredData, readonly }) => (
  <div>
    {voterRequiredData.fullName && <div><Field
      name="voter.fullName"
      component={FormTextField}
      label="Imię i nazwisko"
      fullWidth
      validate={voterRequiredData.fullNameOptional ? undefined : required}
      disabled={readonly}
    /></div>}
    {voterRequiredData.address && <div><Field
      name="voter.address"
      component={FormTextField}
      label="Adres zamieszkania"
      fullWidth
      validate={voterRequiredData.addressOptional ? undefined : required}
      disabled={readonly}
    /></div>}
    <Grid container spacing={1}>
      {voterRequiredData.pesel && <Grid item xs><Field
        name="voter.pesel"
        component={FormTextField}
        label="Pesel"
        validate={[voterRequiredData.peselOptional ? undefined : required, pesel]}
        disabled={readonly}
      /></Grid>}
      {voterRequiredData.phoneNumber && <Grid item xs><Field
        name="voter.phoneNumber"
        component={FormTextField}
        label="Numer telefonu"
        validate={voterRequiredData.phoneNumberOptional ? phoneNumberOptional : phoneNumberRequired}
        disabled={readonly}
      /></Grid>}
      {voterRequiredData.email && <Grid item xs><Field
        name="voter.email"
        component={FormTextField}
        label="Adres e-mail"
        type="email"
        validate={voterRequiredData.emailOptional ? email : [required, email]}
        disabled={readonly}
      /></Grid>}
      {voterRequiredData.gender && <Grid item xs><Field
        name="voter.gender"
        component={FormSelect}
        label="Płeć"
        values={[{ value: 'female', name: 'kobieta' }, { value: 'male', name: 'mężczyzna' }]}
        validate={voterRequiredData.genderOptional ? undefined : required}
        disabled={readonly}
      /></Grid>}
      {voterRequiredData.age && <Grid item xs><Field
        name="voter.age"
        component={FormSelect}
        label="Wiek"
        values={[{ value: 'lessThan30', name: 'poniżej 30 lat' }, { value: 'between3145', name: 'od 31 do 45 lat' }, { value: 'between4660', name: 'od 46 do 60 lat' }, { value: 'greaterThan60', name: 'powyżej 60 lat' }]}
        validate={voterRequiredData.ageOptional ? undefined : required}
        disabled={readonly}
      /></Grid>}
      {voterRequiredData.status && <Grid item xs><Field
        name="voter.status"
        component={FormSelect}
        label="Status zawodowy"
        values={[{ value: 'student', name: 'uczeń/student' }, { value: 'working', name: 'pracujący' }, { value: 'unemployed', name: 'niepracujący' }, { value: 'pensioner', name: 'emeryt/rencista' }]}
        validate={voterRequiredData.statusOptional ? undefined : required}
        disabled={readonly}
      /></Grid>}
      {voterRequiredData.birthYear && <Grid item xs><Field
        name="voter.birthYear"
        component={FormTextField}
        label="Rok urodzenia"
        type="number"
        parse={Number}
        validate={voterRequiredData.birthYearOptional ? year : [required, year]}
        disabled={readonly}
      /></Grid>}
    </Grid>
  </div>
);

ApplicantDataNaturalPerson.propTypes = {
  voterRequiredData: PropTypes.object.isRequired,
  readonly: PropTypes.bool,
};

export default ApplicantDataNaturalPerson;



// WEBPACK FOOTER //
// ./src/components/budget/ApplicantDataNaturalPerson.js